import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthenticationService} from '../_services/authentication.service';

/**
 * A guard that checks if a user is logged in before allowing the router to navigate to a route.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);


  private isLoggedIn: boolean;

  constructor() {
    this.authenticationService.isUserLoggedIn$.subscribe(b => this.isLoggedIn = b);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.isLoggedIn || this.router.createUrlTree(['/login'], {queryParams: {returnUrl: state.url}});
  }

}
